import { withTracking } from '../../../observability';
import { createBuilderModule } from '../../../builder';
import { RegistrationForm } from './RegistrationForm';
import { withChildren } from '@builder.io/react';
import { TIME_INPUT } from '../utils';

export default createBuilderModule(
  withChildren(
    withTracking(RegistrationForm, {
      sectionName: 'RegistrationForm',
    }),
  ),
  {
    name: 'RegistrationForm',
    inputs: [
      {
        name: 'heading',
        type: 'string',
      },
      TIME_INPUT,
      { name: 'place', type: 'string' },
      { name: 'headingImage', type: 'cloudinaryImage' },
      { name: 'logo', type: 'cloudinaryImage' },
    ],
  },
);
